import moment from 'moment';
import request from 'superagent';
import { Query } from 'acast-reactor';
import { Episode } from 'resources';
import updateEntity from 'app/entity/actions/update';
import { moveEpisodeToEpisodes } from 'resources/show';
import { trackOperation } from 'app/operations';
import store from 'app/store';
import Config from 'app/config';
import { getUserToken } from 'services/authentication';
import PublishHistory from 'resources/episode-publish-history';

function runPublishAPICall(episode) {
  return new Promise((resolve, reject) => {
    const API_HOST = Config.get('CREATE_API_HOST');

    request
      .post(`${API_HOST}/api-v2/acasts/${episode.id}/publish`)
      .set('Authorization', `Bearer ${getUserToken()}`)
      .send(episode)
      .end((err, res) => {
        if (err) {
          return reject(err);
        }
        // TODO: The res.body here should be the published episode so that
        //       we can re-inject it into our store. Otherwise we have to
        //       do what we do now which is to make an extra call to load it.
        return resolve(res.body || episode);
      });
  });
}

function readBackEpisodeAfterPublish(episode) {
  return new Promise((resolve, reject) => {
    Query.run('episode/read', episode.id)
      .then(result => resolve(result.value))
      .catch(error => reject(error));
  });
}

function updateLocalEntityFromResult(result) {
  return store.dispatch(Episode.Actions.update(result.id, result));
}

function setEntityModifiedToMatchPublished(result) {
  const updated = result.merge({
    modified: result.publishedOn,
  });
  return updateEntity(Episode, updated, { noModifiedOverride: true });
}

function reloadPublishHistory(episode) {
  return store.dispatch(PublishHistory.read(episode.id, true)).then(() => episode);
}

function runPublishEpisode(episode, publishDate, options = {}) {
  let updatedEpisode = episode.merge({ publishDate });

  if (options.setModifiedDate === true) {
    updatedEpisode = updatedEpisode.merge({ modified: publishDate });
  }

  return updateEntity(Episode, updatedEpisode, { noModifiedOverride: true })
    .then(runPublishAPICall)
    .then(reloadPublishHistory)
    .then(readBackEpisodeAfterPublish)
    .then(updateLocalEntityFromResult)
    .then(setEntityModifiedToMatchPublished)
    .then(() => moveEpisodeToEpisodes(episode));
}

export default (episode, date = null, options = {}) => {
  let publishDate = date;
  if (publishDate === null || publishDate === undefined) {
    publishDate = new Date().toISOString();
  } else if (moment(publishDate).isValid()) {
    publishDate = moment(publishDate).toISOString();
  } else {
    throw new Error(`
      Invalid publish date specified. Should either be null to
      publish right now, otherwise a valid date object or iso
      date string.
    `);
  }

  const operation = runPublishEpisode(episode, publishDate, options);
  const id = `${episode.id}/publish`;

  return store.dispatch(trackOperation(operation, id)).catch(error => {
    // eslint-disable-next-line
    console.log('Unable to publish episode', error);
    throw error;
  });
};
